import { Navigate } from "react-router";
import { Role } from "../state/api.types";
import { useAuthHasRole } from "../state/hooks";
import { useTypedSelector } from "../state/store";

type AppRedirectProps = {
  appPath?: string;
};

export const AppRedirect = ({ appPath }: AppRedirectProps) => {
  const { appSlug } = useTypedSelector((state) => state.local);
  const hasPermission = useAuthHasRole(Role.Developer, Role.OrgAdmin);

  if (!appSlug) {
    return <Navigate replace to="/apps" />;
  }

  if (appPath) {
    // Omit any path params and send them to the root page instead. We can't
    // guarantee the ID they're trying to hit is tied to the app they'll be
    // directed to, so we'll just send them as close as we can.
    const resolvablePath = appPath.split(":").slice(0, 1)[0];
    return <Navigate replace to={`/apps/${appSlug}/${resolvablePath}`} />;
  }

  const defaultPage = hasPermission ? "" : "accounts";
  return <Navigate replace to={`/apps/${appSlug}/${defaultPage}`} />;
};
